import { defineMessages } from 'react-intl';

// eslint-disable-next-line perfectionist/sort-object-types
/* eslint-disable perfectionist/sort-object-types */
export const messages: {
	label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	/* eslint-enable perfectionist/sort-object-types */
} = defineMessages({
	label: {
		id: 'navigation.global-shortcuts.apps.feedback',
		defaultMessage: 'Feedback',
		description:
			'The text is shown as a navigation link label in the global shortcuts feedback app, allowing users to access the feedback feature.',
	},
});
